var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ApiService } from '@app/utility/api.service';
import * as CryptoJS from 'crypto-js';
var LoginSocialComponent = /** @class */ (function () {
    function LoginSocialComponent(api) {
        this.api = api;
        this.title = 'EncryptionDecryptionSample';
        this.plainText = "";
        this.encPassword = "w!z%C*F-JaNdRfUjXn2r5u8x/A?D(G+K";
        this.decPassword = "w!z%C*F-JaNdRfUjXn2r5u8x/A?D(G+K";
        this.iv = "";
        this.salt = "";
        this.password = "";
        this.plainToEncrypt = "";
        this.encrypted = "";
        this.passwordToEncrypt = "";
        this.plainFromDecrypt = "";
        this.encryptedToDecrypt = "";
        this.passwordToDecrypt = "";
        this.api.getCustomAPI("Key", "GetKey");
    }
    LoginSocialComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    //method is used to encrypt and decrypt the text  
    LoginSocialComponent.prototype.convertText = function (conversion) {
        var enKey = CryptoJS.enc.Utf8.parse(this.encPassword.trim());
        var deKey = CryptoJS.enc.Utf8.parse(this.decPassword.trim());
        if (conversion == "encrypt") {
            this.conversionEncryptOutput = CryptoJS.AES.encrypt(this.plainText.trim(), enKey, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }).toString().trim();
            this.encryptText = this.conversionEncryptOutput;
        }
        else {
            this.conversionDecryptOutput = CryptoJS.AES.decrypt(this.encryptText.trim(), deKey, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }).toString(CryptoJS.enc.Utf8).trim();
        }
    };
    LoginSocialComponent.prototype.drosEncrypt = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = {
                            iv: this.iv,
                            salt: this.salt,
                            password: this.password,
                            plainText: this.plainToEncrypt
                        };
                        return [4 /*yield*/, this.api.postCustomApi("Dros", "DrosEncrypt", req)];
                    case 1:
                        res = _a.sent();
                        this.passwordToEncrypt = res.key || "";
                        this.encrypted = res.encrypted || "";
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginSocialComponent.prototype.drosDecrypt = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = {
                            iv: this.iv,
                            salt: this.salt,
                            password: this.password,
                            encrypted: this.encryptedToDecrypt
                        };
                        return [4 /*yield*/, this.api.postCustomApi("Dros", "DrosDecrypt", req)];
                    case 1:
                        res = _a.sent();
                        this.passwordToDecrypt = res.key || "";
                        this.plainFromDecrypt = res.encrypted || "";
                        return [2 /*return*/];
                }
            });
        });
    };
    return LoginSocialComponent;
}());
export { LoginSocialComponent };



// WEBPACK FOOTER //
// ./src/app/login-social/login-social.component.ts.pre-build-optimizer.js